import React from 'react';
import WistiaVideoPlayer from "../../../common/media/WistiaVideoPlayer";
import {Icon} from "in-touch-icons";
import Anchor from "../../objects/Anchor";


const VideoModal = (props) => {

    const {closeModal, modalState, videoUrl } = props;

    if (modalState === false) {
        return null;
    }

    return (
        <div className="video-modal">
            <span className="modal-bg-close" onClick={() => closeModal()}></span>
            <div className="modal-inner">
                <button type="button" className="modal-close" onClick={() => closeModal()}>
                    <Icon iconName={'close'} fill={'black'}/>
                </button>
                <WistiaVideoPlayer url={videoUrl}/>
                {/*If showFoot prop is true*/}
                {props.showFoot &&
                    <div className="modal-foot-whole">
                        <div className="modal-foot">
                            <h3 className="heading-three">{props.data.title}</h3>
                            <p className="body-copy">Interested in this course? Click the "Go to course" button to start improving your skills by completing the course.</p>
                        </div>
                        <div className="modal-foot link-cta">
                            <button className="clickable" onClick={() => closeModal()}>
                                No thank you
                            </button>
                            <Anchor internal path={`/training/interactive-webinars/${props.data.uid}`} anchorClass={'theme-button'}>
                                Go to course
                            </Anchor>
                        </div>
                    </div>
                }
            </div>
        </div>
    );
};

export default VideoModal;


// WEBPACK FOOTER //
// src/client/components/dashboardNew/components/modals/VideoModal.js